import { Component, OnInit } from "@angular/core";
import { Router, ActivatedRoute, Params } from "@angular/router";
import { Usuario } from "../usuario/usuario";
import { UsuarioService } from "../usuario/usuario.service";
import { ResponsaveisService } from "./selecao-responsaveis.service";
import { Responsavel } from "./selecao-responsaveis";

@Component({
  selector: "app-selecao-responsaveis",
  templateUrl: "./selecao-responsaveis.component.html",
  styleUrls: ["./selecao-responsaveis.component.css"],
  providers: [UsuarioService, ResponsaveisService]
})
export class SelecaoResponsaveisComponent implements OnInit {
  responsavel: Responsavel;
  usuario: Usuario;
  usuarios_acolhimento: Usuario[];
  usuarios_geral: Usuario[];
  //id_usuarios_selecionados: ;
  id: number;
  id_perfil: number;
  incidente_id: number;
  id_responsavel_acolhimento: number;
  id_responsavel_geral: number;

  listarResponsaveis(): void {
    this.route.params.forEach((params: Params) => {
      let id = params["id"]; // id do incidente

      this.responsavel.id_incidente = id;

      this.responsavelService.obterResponsaveisPorIdIncidente(id).then(responsavel => {
        //console.log('responsaveis:');
        //console.log(responsavel["dados"]);
        //this.usuarios_acolhimento = usuario['dados'];
        this.responsavel.id_responsavel_acolhimento =
          responsavel["dados"]["id_responsavel_acolhimento"];
        this.responsavel.id_responsavel_geral =
          responsavel["dados"]["id_responsavel_geral"];
      });

      //if (id !== undefined) {
      this.usuarioService.getUsuariosPorPerfil(4).then(usuario => {
        //console.log(usuario["dados"]);
        this.usuarios_acolhimento = usuario["dados"];
      });

      this.usuarioService.getUsuariosPorPerfil(5).then(usuario => {
        //console.log(usuario["dados"]);
        this.usuarios_geral = usuario["dados"];
      });
      //}
    });
    //console.log(this.usuarios);
  }

  constructor(
    private responsavelService: ResponsaveisService,
    private usuarioService: UsuarioService,
    private route: ActivatedRoute,
    private router: Router
  ) {
    this.usuario = new Usuario();
    this.responsavel = new Responsavel();
  }

  ngOnInit() {
    this.listarResponsaveis();
  }

  salvarResponsaveis(): void {
    if (this.responsavelService.saveSelecao(this.responsavel) !== undefined) {
      //this.responsavelService.saveSelecao(this.responsavel).then(() => this.goBack());
      this.goBack();
      //console.log(this.responsavel);
      //console.log("salvo!");
    }
  }

  goBack(): void {
    this.router.navigate(["/denuncias"]);
  }
}



// WEBPACK FOOTER //
// ./src/app/selecao-responsaveis/selecao-responsaveis.component.ts